import { render, staticRenderFns } from "./QuestionForYou.vue?vue&type=template&id=4499171a&scoped=true&"
import script from "./QuestionForYou.vue?vue&type=script&lang=js&"
export * from "./QuestionForYou.vue?vue&type=script&lang=js&"
import style0 from "./QuestionForYou.vue?vue&type=style&index=0&id=4499171a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4499171a",
  null
  
)

export default component.exports